import React from "react";
import {subduedTextColour} from "../../style/styleConsts";
import {Tooltip} from "antd";
import {useSelector} from "react-redux";

const wordStyle = {
  backgroundColor: subduedTextColour,
  opacity: 0.1,
  height: "1em",
  display: "inline-block",
  marginRight: "0.5em",
  marginTop: 5
};

export const RedactedCommentPlaceholder = () => (
    <Tooltip title="Comments have been redacted."  mouseLeaveDelay={0} mouseEnterDelay={1}>
        <div className="t-redacted-comment" style={{cursor: "help"}}>
            <span style={{...wordStyle, width: "5em"}}>&nbsp;</span>
            <span style={{...wordStyle, width: "1em"}}>&nbsp;</span>
            <span style={{...wordStyle, width: "4em"}}>&nbsp;</span>
            <span style={{...wordStyle, width: "3em"}}>&nbsp;</span>
            <span style={{...wordStyle, width: "5em"}}>&nbsp;</span>
            <span style={{...wordStyle, width: "1em"}}>&nbsp;</span>
            <span style={{...wordStyle, width: "4em"}}>&nbsp;</span>
            <span style={{...wordStyle, width: "3em"}}>&nbsp;</span>
        </div>
    </Tooltip>
);

export const RedactCommentary = ({children}) => {
    const commentsRedacted = useSelector(state => state.userIdentity.commentsRedacted);
    if (commentsRedacted)
        return <RedactedCommentPlaceholder/>;
    else
        return children;
};
